import React, { useState } from "react";
import { Typography, Card, Pagination, Tooltip, IconButton, Link, Grid } from "@mui/material";
import { useTheme } from "@emotion/react";
import DeleteIcon from '@mui/icons-material/Delete';
import HistoryInfoSection from "./HistoryInfoSection";
import {StyledH3Heading, StyledGrid}  from "../style/StyledComponents";

const CHARACTER_LIMIT = 18;
const getFirstXCharacters = (s) => {
    return s && s.substr(0, CHARACTER_LIMIT) + "...";
}

function DeleteTabButton({embedId, handleDeleteEvent}) {
    const theme = useTheme();
    return (
      <>
        <Tooltip title="Delete button would delete the section and corresponding notes" size="md" arrow>
            <IconButton
                key={embedId}
                onClick={(e) => {e.preventDefault(); handleDeleteEvent(embedId)}}
            >
                <DeleteIcon height={"8px"} width={"8px"} sx={{color: theme.palette.secondary.main}}/>
            </IconButton>
        </Tooltip>
      </>
    );
  }

const HistoryBoard = ({ videos, 
                        handleVideoClickOnHistory,
                        handleDeleteClickOnHistory
                     }) => {
  
  
  const theme = useTheme();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const Iconstyle = { width: '100%', height: "100%", objectFit: 'cover', cursor: 'pointer' };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = videos ? videos.slice(indexOfFirstItem, indexOfLastItem) : [];

  return (
    <>
      <StyledGrid container sx={{padding: "2rem"}}>
        <Grid item>
            <StyledH3Heading>History</StyledH3Heading>
        </Grid>
        <Grid item sx={{color: theme.palette.primary.main}}>
            <HistoryInfoSection />
        </Grid>
      </StyledGrid>
      <StyledGrid container spacing={2}>
          {currentItems.map((video) => (
            <Grid item key={video.id}>
              <Card sx={{
                    minWidth: "120px",
                    maxWidth: "200px",
                    padding: "2px",
                    width: '100%',
                    position: 'relative',
                    overflow: 'hidden',
                    }}>
              <img
                src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
                alt={video.title}
                style={Iconstyle}
                onClick={() => handleVideoClickOnHistory(video.id)} />
                <Grid container>
                    <Grid item xs={10}>
                        <Typography
                        variant="body1"
                        >
                        <Link sx={{ cursor: 'pointer' }}
                            onClick={() => handleVideoClickOnHistory(video.id)}
                        > {getFirstXCharacters(video.title)}</Link>
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <DeleteTabButton 
                            embedId={video.id}
                            handleDeleteEvent={handleDeleteClickOnHistory}
                        />
                    </Grid>
                </Grid>
              </Card>
            </Grid>
          ))}
        </StyledGrid>
        <Pagination
          count={Math.ceil(videos.length / itemsPerPage)}
          page={currentPage}
          onChange={handlePageChange}
          style={{ margin: "20px" }}
        />
      </>
  );
};

export default HistoryBoard;